import { animated } from 'react-spring';
import { useAnimation, UseAnimationProps } from '../use-animation/UseAnimation';

export type IcoAnimatedProps = {
    children: React.ReactNode;
} & UseAnimationProps;

export const IcoAnimated = (props: IcoAnimatedProps): JSX.Element => {
    const { children, x = 0, y = 0, rotation = 0, scale = 1, timing = 150, tension = 300, friction = 10 } = props;

    const [style, trigger] = useAnimation({
        x,
        y,
        rotation,
        scale,
        timing,
        tension,
        friction,
    });
    return (
        <animated.span onMouseEnter={trigger} onTouchEnd={trigger} style={{ ...style, display: 'inline-flex' }}>
            {children}
        </animated.span>
    );
};
